export default [
  { title: 'Add new user', icon: 'mdi-plus', action: 'addNew', _enabled: true }
  // { title: 'Recover', icon: 'mdi-delete-restore' },
  // { title: 'Import', icon: 'mdi-publish' }
];
